
import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { FuncionesProvider } from '../../providers/funciones/funciones';

/**
 * Generated class for the VerimagenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-verimagen',
  templateUrl: 'verimagen.html',
})

export class VerimagenPage {
  muestragif = "";
  imagenobtenida;
  imagenes;
  imaahora;
  grupoid;
  tabla;
  caption: string;

  constructor(
  	public navCtrl: NavController,
  	public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public params: NavParams,
    public viewCtrl: ViewController,
    public variables:VariablesProvider

    ) {
    
    this.caption = params.get('caption');
    this.grupoid = params.get('idgrupo');
    this.tabla = params.get('tabla');

   	//console.log("ID=" +  this.grupoid);
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad VerimagenPage');
	this.imagenobtenida = [];

				

this.imaahora ="";

this.variables.obtenerimagen(this.tabla ,"imagen",this.grupoid).then(
data => {

		this.imagenobtenida = data;


			for (var x = 0; x < this.imagenobtenida.length; x++) {
		
			this.imaahora = "data:image/jpeg;base64," + this.imagenobtenida[x].VALOR;
			//console.log("Entra aqui");
					
			break;
	}

})

  }


 dismiss() {
    //console.log("Se va...");
    this.viewCtrl.dismiss(
      {
        'trabajadores': "this.puestos",
        'turnos': "this.turnos"
      }
    ); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/verimagen/verimagen.ts